import React from 'react';

import utils from '../../utils/utils';
import avatar from '../../assets/images/avatar-50.png';
import { TieFlag } from './TablaPicksGrupoSurvivor';

class MisPicks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (!this.props.withRegister) {
      return null;
    }

    const myStandingRow = this.props.picksGrupal?.items?.find(
      (s) => s.survivor_entry_id === this.props.myEntry.id
    )

    const rankFromStanding = this.props.myEntry.survivor_standing?.rank
    const rankFromEntry = this.props.myEntry.rank

    // Tratamos de obtener el rank mas actualizado, si ya cargo mi posicion en el listado
    // lo tomamos de la fila que llega desde el socket, si no, tomamos el rank de la entrada
    const displayRank = myStandingRow?.rank ?? rankFromStanding ?? rankFromEntry
    const rankLabel = displayRank != null && displayRank !== '' ? `${String(displayRank)}°` : '0°'

    let dataList = this.props.survivorWeeks.map((week) => {
      let currentPick = this.props?.myEntry?.survivor_picks ? this.props?.myEntry?.survivor_picks[week.id] : null;
      let isThisWeek = week.id === this.props.currentWeek.id;

      if (!currentPick) {
        return (
          <div key={week.id} className="item-container">
            <div className="img-container">
              {isThisWeek && this.props.myEntry.survivor_standing.alive ? (
                <div className="shirt-picks withoutPick">
                  <i className="ion-close" style={{ color: 'rgb(244,0,52)' }}></i>
                </div>
              ) : this.props.myEntry.survivor_standing.elimination_week_id < week.id ? null : (
                <div className="shirt-picks withoutPick underline">
                  <i className="ion-close" style={{ color: 'rgb(244, 0, 52)' }}></i>
                </div>
              )}
            </div>
          </div>
        );
      } else {
        currentPick['eliminated_this_week'] =
          this.props.myEntry.survivor_standing.elimination_week_id === week.id;

        let teamSelected = this.props.survivorTeams.find((team) => team.id === currentPick.pick);
        const pickFixtureId = currentPick.fid ?? currentPick.fixture_id;
        let correspondingFixture = this.props.survivorFixtures.find((fixture) => fixture.id === pickFixtureId)

        const isTiePick = currentPick?.pick === null && (currentPick?.tie === true || currentPick?.tie === 1);

        // If it is a survivor eliminator (Participant picks the losing team)
        // In that case we look up the fixture and invert whether the winner is the losing team or the winning team
        if (this.props.survivorInfo?.eliminator == 1) {
          const fixture = correspondingFixture
            || this.props.allFixtures?.fixtures?.[week.id]?.find(fixt => fixt.id === pickFixtureId);

          const winningPick = fixture?.winning_pick;

          if (winningPick === 'tie') {
            currentPick.correct = true;
          } else {
            // Invert the fixture winner because for this survivor, the "winning" team is the one that loses
            const effectiveWinner = winningPick === 'home' ? 'away' : 'home';
            const isPickHome = currentPick.pick === fixture?.home_team?.id;

            currentPick.correct = false;

            if (effectiveWinner === 'home' && isPickHome) {
              currentPick.correct = true;
            } else if (effectiveWinner === 'away' && !isPickHome) {
              currentPick.correct = true;
            }
          }
        }

        let tieFixture = null;
  
        if (isTiePick) {
          tieFixture = this.props.allFixtures.fixtures[week.id].find(fixt => fixt.id === pickFixtureId)
        }
        
        // Para semanas anteriores
        // ------------------------------------------
        if (week.id <= this.props.currentWeek.id) {
          // console.log('this or previous pick')
          if (!teamSelected && !isTiePick) {
            // console.log('Not Team Selected');
            return (
              <div key={week.id} className="item-container">
                <div className="img-container">
                  <i className="ion-close" style={{ color: 'rgb(244,0,52)' }}></i>
                </div>
              </div>
            );
          } else {
            // console.log('This pick isnt this week' , correspondingFixture , currentPick );
            if (correspondingFixture === -1 || correspondingFixture === undefined) {
              let pickStatus = '';
              if (currentPick.strike) {
                if (currentPick.eliminated_this_week) {
                  pickStatus = 'strike underline';
                } else {
                  pickStatus = 'strike';
                }
              } else if (currentPick.correct) {
                pickStatus = 'gano';
              } else if (!currentPick.correct) {
                pickStatus = 'perdio';
              }
              // console.log( 'PickStatus',pickStatus , currentPick);
              return (
                <div key={week.id} className="item-container">
                  <div className="img-container">

                    {!isTiePick && (
                      <div className={`shirt-picks ${pickStatus}`}>
                        <i className={` home helmet ${teamSelected.logo}`}></i>
                        <small className="team-name">
                          {teamSelected.abbreviation}
                          {this.props.pointFormat === 'line' ? (
                            <span className="linea">{currentPick.advantage}</span>
                          ) : null}
                        </small>
                      </div>
                    )}

                    {isTiePick && (
                      <div className={`shirt-picks ${pickStatus}`} style={{ marginTop: '2px' }}>
                        <TieFlag
                        >
                          E
                        </TieFlag>

                        <small className="team-name" style={{ fontSize: '9px' }}>
                          {tieFixture?.home_team?.abbreviation}
                          {tieFixture?.home_team?.abbreviation && tieFixture?.away_team?.abbreviation
                            ? ' - '
                            : ''}
                          {tieFixture?.away_team?.abbreviation}{' '}
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              );
            } else {
              // console.log('This week fixture');
              // console.log('correspondingFixt', correspondingFixture );
              /**
               * Live Pick
               */
              let pickStatus = '';
              if (!correspondingFixture.enabled) {
                if (currentPick.strike) {
                  if (currentPick.eliminated_this_week) {
                    pickStatus = 'strike underline';
                  } else {
                    pickStatus = 'strike';
                  }
                } else if (currentPick.correct) {
                  pickStatus = 'gano';
                } else {
                  pickStatus = 'perdio';
                }
              }
              if (!correspondingFixture.enabled && !correspondingFixture.finished) {
                // console.log( pickStatus );
                return (
                  <div key={week.id} className="item-container">
                    <div className="img-container">
                      {!isTiePick && (
                        <div className={`shirt-picks ${pickStatus} `}>
                          <i className={` home helmet ${teamSelected.logo}`}></i>
                          <small className="team-name">
                            {teamSelected.abbreviation}
                            {this.props.pointFormat === 'line' ? (
                              <span className="linea">{currentPick.advantage}</span>
                            ) : null}
                          </small>

                        </div>
                      )}


                      {isTiePick && (
                        <div className={`shirt-picks ${pickStatus}`} style={{ marginTop: '2px' }}>
                          <TieFlag
                          >
                            E
                          </TieFlag>

                          <small className="team-name" style={{ fontSize: '9px' }}>
                            {tieFixture?.home_team?.abbreviation}
                            {tieFixture?.home_team?.abbreviation && tieFixture?.away_team?.abbreviation
                              ? ' - '
                              : ''}
                            {tieFixture?.away_team?.abbreviation}{' '}
                          </small>
                        </div>
                      )}

                    </div>
                  </div>
                );
              } else {
                /**
                 * Closed Pick
                 */
                let pickStatus = '';
                if (!correspondingFixture.enabled) {
                  if (currentPick.strike) {
                    pickStatus = 'strike';
                  } else if (currentPick.correct) {
                    pickStatus = 'gano';
                  } else {
                    pickStatus = 'perdio';
                  }
                }
                return (
                  <div key={week.id} className="item-container">
                    <div className="img-container">

                      {!isTiePick && (
                        <div className={`shirt-picks ${pickStatus}`}>

                          <i className={` home helmet ${teamSelected.logo}`}></i>
                          <small className="team-name">
                            {teamSelected.abbreviation}
                            {this.props.pointFormat === 'line' ? (
                              <span className="linea">{currentPick.advantage}</span>
                            ) : null}
                          </small>
                        </div>
                      )}

                      {isTiePick && (
                        <div className={`shirt-picks ${pickStatus}`} style={{ marginTop: '2px' }}>
                          <TieFlag
                          >
                            E
                          </TieFlag>

                          <small className="team-name" style={{ fontSize: '9px' }}>
                            {tieFixture?.home_team?.abbreviation}
                            {tieFixture?.home_team?.abbreviation && tieFixture?.away_team?.abbreviation
                              ? ' - '
                              : ''}
                            {tieFixture?.away_team?.abbreviation}{' '}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
            }
          }
        } else {
          return (
            <div key={week.id} className="item-container">
              <div className="img-container">
                {!isTiePick && (
                  <div className={`shirt-picks `}>

                    <i className={` home helmet ${teamSelected?.logo}`}></i>
                    <small className="team-name">
                      {teamSelected?.abbreviation}
                      {this.props?.pointFormat === 'line' ? (
                        <span className="linea">{currentPick?.advantage}</span>
                      ) : null}
                    </small>

                  </div>
                )}

                {isTiePick && (
                  <div className={`shirt-picks`} style={{ marginTop: '2px' }}>
                    <TieFlag
                    >
                      E
                    </TieFlag>

                    <small className="team-name" style={{ fontSize: '9px' }}>
                      {tieFixture?.home_team?.abbreviation}
                      {tieFixture?.home_team?.abbreviation && tieFixture?.away_team?.abbreviation
                        ? ' - '
                        : ''}
                      {tieFixture?.away_team?.abbreviation}{' '}
                    </small>
                  </div>
                )}
              </div>
            </div>
          )
        }
      }
    });

    let userList = (
      <ul className="list-unstyled lower-list">
        <li className="lower-table-item user ownUser">
          <div className="item-container">
            <div className="image-container">
              <img
                className="avatarPicksGrupo"
                src={
                  utils.isLogged() && utils.getUserInfo().avatar === '/img/profile-image-01.png'
                    ? avatar
                    : utils.isLogged() &&
                    utils.getUserInfo().avatar_dir + utils.getUserInfo().avatar
                }
                alt=""
              />
            </div>
            <span className="picks-rank">{rankLabel}</span>
            <span style={{ fontWeight: 'bold' }}>
              {utils.isLogged() ? utils.getUserInfo().nick : 'NA'}
              {this.props.myEntry.number !== null ? (
                <sup
                  style={{
                    fontWeight: 'lighter',
                    fontSize: '75%',
                    margin: '0 2px',
                  }}
                >
                  {this.props.myEntry.number}
                </sup>
              ) : (
                ''
              )}
            </span>
          </div>
        </li>
      </ul>
    );

    let totalList = (
      <ul className="list-unstyled lower-list" style={{ width: '100%' }}>
        <li className="lower-table-item user ownUser">
          <div className="item-container">
            <div className="shirt-picks ">
              <i
                className={
                  this.props.myEntry.survivor_standing.alive ? 'ion-checkmark' : 'ion-close'
                }
                style={
                  this.props.myEntry.survivor_standing.alive
                    ? { color: 'rgb(120,180,40)' }
                    : { color: 'rgb(224,0,52)' }
                }
              />
            </div>
          </div>
        </li>
      </ul>
    );

    return (
      <div className="lista-container ownUser">
        <div className="userList ownUser">{userList}</div>
        <div className="dataList ownUser sync-horizontal">
          <div className="lower-table-item">{dataList}</div>
        </div>
        <div className="totalesList ownUser" style={{ width: '7%' }}>
          {totalList}
        </div>
      </div>
    );
  }
}

export default MisPicks;
